import data from "./data";
import Card from "./Card";
import "./css/Cars.css";
import { useNavigate } from "react-router-dom";

const Cars = () => {
  const navigate = useNavigate();
  return (
    <div className="cars">
      <div className="cars-topbar">
        <img src="images/Logo3.jpg" alt="" />
        <ul>
          <li class="btn btn-primary" onClick={() => navigate("/")}>
            Home
          </li>
        </ul>
      </div>
      <div className="cars-body">
        {data.map((d) => (
          <Card info={d} />
        ))}
      </div>
    </div>
  );
};

export default Cars;
